import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useMsal } from '@azure/msal-react';

// ---
interface authType { 
   scope: string, value?: string, children?: React.ReactNode,
   handleAuthenticate: (data: { accessToken: string, idToken: string, expiresOn: Date }) => void
}

// ---
const MicrosoftLoginComponent = ({ scope, value, handleAuthenticate, children }: authType) => {
   const { instance } = useMsal();

   const login = () => {
      instance.loginPopup({ scopes: [`${scope} offline_access`] })
      .then(response => { 
         console.log(response);
         handleAuthenticate({ accessToken: response.accessToken, idToken: response.idToken, expiresOn: response.expiresOn as Date });
      })
      .catch(error => console.log('Login Failed:', error));
   };

   return children ? <div onClick={ _=> login() }>{ children }</div> : <button className="btn1 line" onClick={ login }>{ value || 'Authenticate' }</button>
}

export default function MicrosoftLoginWrapper(props: authType) {
   const msalConfig = {
      auth: {
         clientId: 'fd14c7ae-8b5e-4c97-ad6e-9b5842ee69c7',
         authority: 'https://login.microsoftonline.com/common',
         redirectUri: window.origin,
         grant_type: 'authorization_code',
      }
   };
   const msalInstance = new PublicClientApplication(msalConfig);

   return (
      <MsalProvider instance={ msalInstance }>
         <MicrosoftLoginComponent { ...props } />
      </MsalProvider>
   );
}